import React, { Component } from 'react'
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';

// Msal imports
import { MsalContext } from "@azure/msal-react";

class Header extends Component {

    static contextType = MsalContext;

    constructor(props) {
        super(props)

        this.state = {
                 
        }
    }

    render() {
        return (
            <header>
                <Navbar bg="dark" variant="dark">
                    <Navbar.Brand href="#home">
                        <img
                            src="/logo.png"
                            width="25"
                            height="30"
                            className="d-inline-block align-top"
                            alt="Logo"
                        />
                        &ensp;Azure AD Explorer
                    </Navbar.Brand>
                    <Navbar.Toggle />
                    <Navbar.Collapse>
                        <Nav className="mr-auto">
                            <Nav.Link href="https://aka.ms/MySecurityInfo">My Security Info</Nav.Link>
                        </Nav>
                        <Navbar.Text>
                            Signed in as: <a href="#login">{this.context.accounts[0].name}</a>
                        </Navbar.Text>
                    </Navbar.Collapse>
                </Navbar>
            </header>
        )
    }
}

export default Header